import { assertAttendanceAccess } from 'v3/pages/ControlTower/Kanban/Attendance/access';
import { attendancePayload } from 'v3/pages/ControlTower/Kanban/Attendance/session';
 
import api, { cooperplaceApi } from 'services/api';
import notificationApi from 'services/apis/notification';
import cargonApi from 'services/apis/cargon';
import { createContext } from 'utils/react-helpers';
import { toReplacementPayload } from 'v3/components/FreightValues/utils';
import moment from 'moment';
import TravelSchema from './validator';

export async function fetchSelectOptions(url, params = {}) {
  try {
    const { data } = await api.get(url, { params });

    return data;
  } catch (err) {
    return [];
  }
}

export const TravelContext = createContext({
  name: 'Add Travel',
  strict: false,
});

async function validate(values, setErrors) {
  const { data, loadGRORangeData } = values;
  const errorList = {};
  const dataObject = {
    clientId: data.client?.value ? data.client?.value : data.client?.id,
    currency: data.currency,
    value: +data.value,
    vehicleId: data.vehicle?.main?.id,
    shippingCompanyId: data?.shippingCompany?.id,
    origin: data?.origin?.address,
    destination: data?.destinations[0]?.address,
    destinations: data?.destinations,
    costCenter: data?.costCenter,
    balance: data?.balance,
    advance_money_percentage_external: Number(data?.advance_money_percentage_external),
    advance_money_percentage: Number(data?.advance_money_percentage),
    company: data?.company?.name,
    fleetVehicleType: data?.vehicle?.main?.fleetType?.name,
    loadId: data?.loadId,
    riskManager: data?.riskManager,
    driver: data?.driver,
    riskManagerSearch: data?.loadGROData?.riskManagerSearch,
    monitoringGroups: data?.loadGROData?.groupEquipment,
    techTracker: data?.loadGROData?.techTracker,
    modelTracker: data?.loadGROData?.modelTracker,
    trackerNumber: data?.loadGROData?.trackerNumber,
    immobilizer: data?.loadGROData?.immobilizer,
    immobilizerNumber: data?.loadGROData?.immobilizerNumber,
    locator: data?.loadGROData?.locator,
    locatorNumber: data?.loadGROData?.locatorNumber,
    baitsAmount: data?.loadGROData?.groupEquipment?.bait_quantity,
    baits: [
      data?.loadGROData?.bait1,
      data?.loadGROData?.bait2,
      data?.loadGROData?.bait3,
      data?.loadGROData?.bait4,
    ].filter(Boolean),
    baitsNumber: [
      data?.loadGROData?.baitNumber1,
      data?.loadGROData?.baitNumber2,
      data?.loadGROData?.baitNumber3,
      data?.loadGROData?.baitNumber4,
    ].filter(Boolean),
  };

  try {
    await TravelSchema.validate(dataObject, {
      abortEarly: false,
      context: {
        riskManager: data?.riskManager,
        shouldInformDriver: !!data?.loadGROData?.id,
        shouldInformRiskManager:
          !!data?.loadGROData?.policyId ||
          (data?.loadGROData?.policyId &&
            loadGRORangeData?.groups?.find(
              group => group.code === 'manager_tracker'
            )?.items?.length > 0),
        shouldInformRiskManagerSearch:
          loadGRORangeData?.groups?.find(
            group => group.code === 'manager_query'
          )?.items?.length > 0,
        shouldInformMonitoringGroup:
          loadGRORangeData?.equipments_groups?.length > 0,
        shouldInformTrackerTech:
          data?.loadGROData?.groupEquipment?.tecnologies?.length > 0,
        shouldInformTrackerModel:
          data?.loadGROData?.groupEquipment?.equipments?.length > 0,
        shouldInformImmobilizer:
          data?.loadGROData?.groupEquipment?.immobilizers?.length > 0,
        shouldInformLocator:
          data?.loadGROData?.groupEquipment?.locators?.length > 0,
        shouldInformBaits: data?.loadGROData?.groupEquipment?.baits?.length > 0,
      },
    });
    setErrors({ ...errorList });

    return true;
  } catch (err) {
    if (Array.isArray(err?.inner)) {
      err.inner.forEach((error) => {
        if (error?.path) errorList[error.path] = error.message;
      });
    } else if (err?.path) {
      errorList[err.path] = err?.message || 'Erro de validação';
    } else if (err?.message) {
      errorList._ = err.message;
    }
    setErrors({ ...errorList });

    return false;
  }
}

async function deleteLoadInTruckpad(id) {
  try {
    await api.post(`integrations/truckpad/load/${id}/cancel`);

    return {
      error: false,
      message: 'Carga cancelada na Truckpad com sucesso.',
    };
  } catch (err) {
    const message = 'Não foi possível cancelar a carga na Truckpad.';
    return { error: true, message };
  }
}

export async function checkIfBlacklisted(
  id,
  onBlacklistedCallback,
) {
  let res;
  try {
    res = await cooperplaceApi.get(`blacklist/search-person/${id}`);
  } catch {
    return null
  } finally {
    const blacklistInfo = res?.data;
    const isBlacklisted = blacklistInfo != null;
    if (isBlacklisted) {
      onBlacklistedCallback(blacklistInfo);
    }
    return isBlacklisted;
  }
}

export async function checkIfBlacklistedVehicle(
  id,
  onBlacklistedCallback,
) {
  let res;
  try {
    res = await cooperplaceApi.get(`blacklist/search-vehicle/${id}`);
  } catch {
    return null
  } finally {
    const blacklistInfo = res?.data;
    const isBlacklisted = blacklistInfo != null;
    if (isBlacklisted) {
      onBlacklistedCallback(blacklistInfo);
    }
    return isBlacklisted;
  }
}

export async function checkIfBlacklistedWagon(
  id,
  onBlacklistedCallback,
) {
  let res;
  try {
    res = await cooperplaceApi.get(`blacklist/search-wagon/${id}`);
  } catch {
    return null
  } finally {
    const blacklistInfo = res?.data;
    const isBlacklisted = blacklistInfo != null;
    if (isBlacklisted) {
      onBlacklistedCallback(blacklistInfo);
    }
    return isBlacklisted;
  }
}


async function deleteLoadInFretebras(id) {
  try {
    await api.post(`integrations/fretebras/load/${id}/cancel`);

    return {
      error: false,
      message: 'Carga cancelada na Fretebras com sucesso.',
    };
  } catch (err) {
    const message = 'Não foi possível cancelar a carga na Fretebras.';
    return { error: true, message };
  }
}

async function deleteLoadInCargon(id) {
  try {
    await cargonApi.post(`/load/cancel`, { load_id: id });

    return {
      error: false,
      message: 'Carga cancelada na Cargon com sucesso.',
    };
  } catch (err) {
    const message = 'Não foi possível cancelar a carga na Cargon.';
    return { error: true, message };
  }
}

async function validateShippingCompany(travel, shippingCompany) {
  const url = `shipping-company/importFromBenner?cpfCnpj=${shippingCompany.cgccpf}&travelId=${travel}`;
  await cooperplaceApi.get(url);
}

async function validateVehicle(dataPayload) {
  try {
    const destination = dataPayload?.destinations?.[dataPayload.destinations.length - 1];
    const payload = {
      originScheduledTime: moment(dataPayload?.origin?.start_schedule).toDate(),
      destinationScheduledTime: moment(destination?.scheduled_time).toDate(),
      vehicleId: dataPayload?.vehicle?.main?.id,
    };
    const response = await api.post('/travel-data/verifyVehicle', payload);
    const { attendedId, isOnAnotherTravel } = response.data;
    return {
      attendedId,
      isOnAnotherTravel,
      error: isOnAnotherTravel,
    };
  } catch (err) {
    return {
      error: true,
    };
  }
}

async function validateDriver(dataPayload) {
  const validation = {
    travels: [],
    isOnAnotherTravel: false,
    error: false,
  };
  try {
    const destination = dataPayload?.destinations?.[dataPayload.destinations.length - 1];
    const payload = {
      originScheduledTime: moment(dataPayload?.origin?.start_schedule).toDate(),
      destinationScheduledTime: moment(destination?.scheduled_time).toDate(),
      driverId: dataPayload?.driver?.id,
    };

    const response = await cooperplaceApi.get('travels/validateDriver', {
      params: payload,
    });

    const { travels } = response.data;
    validation.travels = travels;
    validation.isOnAnotherTravel = !!travels.length;

    return {
      ...validation,
      error: validation.isOnAnotherTravel,
    };
  } catch (err) {
    return {
      ...validation,
      error: true,
    };
  }
}

async function updateCargInputs(freightValues, loadId) {
  let processedInputsExtraFields = [];
  if (freightValues?.discounts?.extras?.length > 0) {
    processedInputsExtraFields = [...freightValues?.discounts?.extras]?.map((item) => {
      return {
        ...item,
        label: item.label.trim(),
        manual: true,
      };
    });
  }

  processedInputsExtraFields.push({
    label: 'Seguro Coopercarga',
    manual: true,
    value: freightValues?.discounts?.coopercargaInsurance?.value,
    showToDriver: false,
  });

  await cooperplaceApi.put(`/carg-inputs`, {
    loadId,
    inputsExtraFields: processedInputsExtraFields,
  });
}

async function updateShipmentDiscounts(freightValues, loadId) {
  const discountsExtraFields = [
    ...freightValues?.shipmentDiscounts?.extras.map((item) => ({
      ...item,
      manual: true,
    })),
  ];

  const issueRateAsExtraField = {
    label: 'Taxa de emissão',
    manual: true,
    value: freightValues?.shipmentDiscounts?.issueRate,
    showToDriver: false,
  };
  discountsExtraFields.push(issueRateAsExtraField);

  return cooperplaceApi.put('carg-shipment-discounts', {
    loadId,
    discountsExtraFields,
  });
}

async function updateShipmentTransfers(freightValues, loadId) {
  const transferExtraFields = [
    ...freightValues?.shipmentTransfers?.extras.map((item) => ({
      ...item,
      manual: true,
    })),
  ];

  return cooperplaceApi.put('carg-shipment-transfers', {
    loadId,
    transferExtraFields,
  });
}

const saveTollsPlaza = async (tollsPlaza, loadId, travelId) => {
  try {
    const payload = {
      travelId: travelId,
      loadId: loadId,
      tollsPlaza: tollsPlaza?.tollsPlaza,
      requestError: tollsPlaza?.requestError,
      totalsTollsPlaza: {
        totalTollValue: tollsPlaza?.totalTollValue,
        totalTollTagValue: tollsPlaza?.totalTollTagValue,
        totalKm: tollsPlaza?.totalKm,
        expectedTime: tollsPlaza?.expectedTime,
        identifierHistory: tollsPlaza?.identifierHistory,
        codPolilyne: tollsPlaza?.codPolilyne,
        totalAxes: tollsPlaza?.totalAxes,
      }
    };

    const response = await cooperplaceApi.post('tollsPlaza/insert-tolls-plaza-load', payload);

    return response.data;

  } catch (error) {
    // ignore
  }
};

const serializePolylineWaypoints = (polylineWaypoints) => {
  if (!polylineWaypoints) return null;
  if (typeof polylineWaypoints === 'string') return polylineWaypoints;
  return JSON.stringify(polylineWaypoints);
};

const toLoadRouteLocationPayload = (location) => ({
  id: location?.id,
  address: location?.address,
  number: location?.number || null,
  complement: location?.complement || null,
  zipCode: location?.zip_code || null,
  lat: location?.lat,
  lng: location?.lng,
  cityId: location?.city?.id || null,
  city: location?.city?.name,
  province: location?.province,
  neighborhood: location?.neighborhood || null,
  formattedAddress: location?.formatted_address || null,
  scheduledTime: moment(location?.scheduled_time).format('YYYY-MM-DD HH:mm:ss'),
  startSchedule: moment(location?.start_schedule).format('YYYY-MM-DD HH:mm:ss'),
  countrySlug: location?.country?.abbreviation,
  clientId: location?.client?.id || location?.clientId || null,
});

const buildLoadRoutePayload = (data, polylineWaypointsPayload) => ({
  totalDistanceInKm: data?.totalDistanceInKm || 0,
  polylineRoute: data?.polylineRoute || null,
  polylineWaypoints: polylineWaypointsPayload,
  origins: [toLoadRouteLocationPayload(data?.origin)],
  destinations: (data?.destinations || []).map(destination => ({
    ...toLoadRouteLocationPayload(destination),
    action: destination?.type?.id,
  })),
});

async function syncLoadRouteFromTravel(data, polylineWaypointsPayload) {
  await cooperplaceApi.put(
    `loads/destination-and-origin/${data?.loadId}`,
    buildLoadRoutePayload(data, polylineWaypointsPayload),
  );
}

/** Devolve o id da viagem salva; sem salvar, devolve um valor falso. */
export async function handleCreation({
  data,
  tollsPlazaInfos,
  freightValues,
  replacementFreightValues,
  setData,
  setErrors,
  showSnackbar,
  setIsLoading,
  setModalName,
  margins,
  confirmMinimiumMargin,
  passDriverValidation,
  loadGRORangeData,
}) {

  let savedAttendance = null;
  setIsLoading(true);
  try {
    await assertAttendanceAccess(data.controlTower);
  } catch (error) {
    showSnackbar(error.message, { type: 'error' });
    setIsLoading(false);
    return false;
  }

  const travelValid = await validate({ data, loadGRORangeData }, setErrors);

  if (!travelValid || !freightValues) {
    showSnackbar('Verifique os campos obrigatórios!', { type: 'error' });
    setIsLoading(false);
    return false;
  }

  if (data?.isReplacement && !replacementFreightValues) {
    showSnackbar('Verifique os campos obrigatórios da troca de nota!', {
      type: 'error',
    });
    setIsLoading(false);
    return false;
  }

  const replacementPayload =
    data?.isReplacement &&
    replacementFreightValues &&
    toReplacementPayload(replacementFreightValues);

  const { isOnAnotherTravel: vehicleIsOnAnotherTravel, attendedId: vehicleAttendedId, error } = await validateVehicle(data);
  if (error) {
    setErrors({
      vehicleId: `Este veículo está em outra viagem neste período! N° da viagem: ${vehicleAttendedId}`,
    });
    setIsLoading(false);
    if (vehicleIsOnAnotherTravel) {
      setErrors({
        vehicleId: `Este veículo está em outra viagem neste período! N° da viagem: ${vehicleAttendedId}`,
      });
      return;
    }

    showSnackbar('Erro ao validar veículo! Tente novamente mais tarde.', { type: 'error' });
    return;
  }

  const {
    error: driverError,
    isOnAnotherTravel: driverIsOnAnotherTravel,
    travels: travelsWithDriver,
  } = await validateDriver(data);

  if (driverError) {
    if (driverIsOnAnotherTravel) {
      if (travelsWithDriver.length >= 2) {
        setIsLoading(false);
        showSnackbar(
          `O motorista está vinculado nas seguintes viagens nesse período: "${travelsWithDriver.join(
            ', ',
          )}"`,
          { type: 'error', duration: 6000 },
        );
        return;
      }

      if (!passDriverValidation) {
        setIsLoading(false);
        setErrors({ travelsWithDriver });
        setModalName('ConflictDriver');
        return;
      }
    } else {
      setIsLoading(false);
      showSnackbar('Erro ao validar motorista! Tente novamente mais tarde.', { type: 'error' });
      return;
    }
  }

  const isMarginAbove = freightValues.travelMargin < margins.benner_margin;
  const isReplacementMarginAbove =
    replacementPayload && replacementPayload.margin < margins?.benner_margin;
  if (!confirmMinimiumMargin && (isMarginAbove || isReplacementMarginAbove)) {
    setModalName('MinimumMargin');
    setIsLoading(false);
    return;
  }

  try {
    setIsLoading(true);

    await Promise.all([
      updateCargInputs(freightValues, data?.loadId),
      updateShipmentDiscounts(freightValues, data?.loadId),
      updateShipmentTransfers(freightValues, data?.loadId),
    ]);

    const polylineWaypointsPayload = serializePolylineWaypoints(data?.polylineWaypoints);

    const travel = {
      load: {
        id: data?.loadId,
        totalDistanceInKm: data?.totalDistanceInKm,
        productId: data?.loadProductId,
        personClientId: data.client.id,
        currency: freightValues?.currency?.value,
        exchange: +data?.exchange || 0,
        exchangeContract: +freightValues?.erpExchangeValue || 0,
        pcpObservation: freightValues?.shipmentTransfers?.pcpObservation,
        advanceMoneyPercentageExternal: +freightValues?.advanceMoneyExternal?.percentage,
        advanceMoneyPercentage: freightValues?.advanceMoney?.percentage,
        totalShipmentTransfer: freightValues?.shipmentTransfers?.total,
        totalShipmentDiscounts: freightValues?.shipmentDiscounts?.total,
        fareCompany: +freightValues?.fareCompany,
        totalInputs: +freightValues?.discounts?.total,
        polylineRoute: data?.polylineRoute || null,
        polylineWaypoints: polylineWaypointsPayload,
        loadOrigins: {
          id: data?.origin?.id,
          address: data?.origin?.address,
          number: data?.origin?.number,
          complement: data?.origin?.complement,
          zipCode: data?.origin?.zip_code,
          lat: data?.origin?.lat,
          lng: data?.origin?.lng,
          cityId: data?.origin?.city?.id || null,
          city: data?.origin?.city?.name,
          province: data?.origin?.province,
          neighborhood: data?.origin?.neighborhood,
          formattedAddress: data?.origin?.formatted_address,
          scheduledTime: moment(data?.origin?.scheduled_time).toDate(),
          startSchedule: moment(data?.origin?.start_schedule).toDate(),
          countrySlug: data?.origin?.country?.abbreviation,
          clientId: data?.origin?.client?.id,
        },
        loadDestinations: data.destinations.map((item) => ({
          id: item?.id,
          action: item?.type?.id,
          address: item?.address,
          number: item?.number,
          complement: item?.complement,
          zipCode: item?.zip_code,
          lat: item?.lat,
          lng: item?.lng,
          cityId: item?.city?.id || null,
          city: item?.city?.name,
          province: item?.province,
          neighborhood: item?.neighborhood,
          formattedAddress: item?.formatted_address,
          scheduledTime: moment(item?.scheduled_time).toDate(),
          startSchedule: moment(item?.start_schedule).toDate(),
          countrySlug: item?.country?.abbreviation,
          clientId: item?.client?.id,
        })),
        replacements: replacementPayload ? [replacementPayload] : [],
      },
      dealId: data?.dealId || null,
      driverId: data.driver?.id || null,
      balance: freightValues?.balance?.value,
      vehicleId: data.vehicle?.main?.id || null,
      shippingCompanyId: data.shippingCompany.id,
      costCenterId: data.costCenter?.id || null,
      travelNumber: data?.load?.id_externo || data?.travelNumber,
      negotiatorComments: data.negotiator_comments,
      negotiatorObservation: freightValues?.shipmentTransfers?.negotiatorObservation,
      margin: freightValues?.travelMargin,
      bennerMargin: margins?.benner_margin,
      wagonIds: [
        data.vehicle?.implement?.id || null,
        data.vehicle?.implement2?.id || null,
        data.vehicle?.implement3?.id || null,
      ].filter(Boolean),
      tagsIds: data?.tags?.map((tag) => tag?.id) || [],
      policyGroupEquipamentId: data?.loadGROData?.groupEquipment?.id,
      policyId: data?.loadGROData?.policyId,
      checklistType: data?.loadGROData?.checklistType,
      riskManagerSearchId: data?.loadGROData?.riskManagerSearch?.id,
      riskManagerId: data?.riskManager?.id,
      trackerId: data?.loadGROData?.techTracker?.id || data?.tracker?.id,
      trackerTypeId: data?.loadGROData?.modelTracker?.id,
      trackerNumber: data?.loadGROData?.trackerNumber,
      trackerImmobilizerId: data?.loadGROData?.immobilizer?.id,
      immobilizerNumber: data?.loadGROData?.immobilizerNumber,
      locatorNumber: data?.loadGROData?.locatorNumber,
      trackerLocatorId: data?.loadGROData?.locator?.id,
      policyOperationId: data?.isGROLoad?.operation?.id,
      baits: [
        {
          id: data?.loadGROData?.bait1?.id,
          number: data?.loadGROData?.baitNumber1,
        },
        {
          id: data?.loadGROData?.bait2?.id,
          number: data?.loadGROData?.baitNumber2,
        },
        {
          id: data?.loadGROData?.bait3?.id,
          number: data?.loadGROData?.baitNumber3,
        },
        {
          id: data?.loadGROData?.bait4?.id,
          number: data?.loadGROData?.baitNumber4,
        },
      ].filter((item) => item?.id),
    };

    const response = await cooperplaceApi.post(
      data.controlTower ? `/control-tower/loads/${data.loadId}/travels` : '/travels',
      { ...travel, ...attendancePayload(data.controlTower) },
    );
    if (data.controlTower && response.data?.id) savedAttendance = response.data.id;
    if (data.controlTower && response.data?.controlTower?.replayed) {
      setData((old) => ({ ...old, registeredTravel: response.data.id }));
      return response.data.id;
    }
    if (response.data?.controlTower?.warning)
      showSnackbar(response.data.controlTower.warning, { type: 'warning' });

    if (response.data?.id) {
      await syncLoadRouteFromTravel(data, polylineWaypointsPayload);
    }

    if (response.data?.id && data?.polylineRoute) {
      saveTollsPlaza(tollsPlazaInfos, travel?.load?.id, response.data?.id);
    }

    try {
      await validateShippingCompany(response.data.id, data.shippingCompany);
    } catch (error) { }

    const attachments = new FormData();

    data.attachments.forEach((item, index) => {
      const fileName = item.file.name
        .replaceAll('_', '-')
        .split('.')
        .slice(0, -1)
        .join('.');
      const fileNameFormatted = `${Date.now()}${index}.${item.file?.type.split('/')[1]
        }`;
      const name = fileName
        ? `${fileName}-${fileNameFormatted}`
        : fileNameFormatted;

      const newFile = new File([item.file.blob], name, {
        type: item.file.type,
      });

      attachments.append('file', newFile);
      attachments.append(`${name}_description`, item.description);
    });

    await api.post(`travel/${response.data.id}/attachments`, attachments);

    if (data.loadId) {
      try {
        deleteLoadInTruckpad(data?.loadId);
        deleteLoadInFretebras(data?.loadId);
        deleteLoadInCargon(data?.loadId);
        notificationApi.post('create', {
          title: data.fiscalData.status_id === 3 ? '📑 Documentação emitida' : '🚛 Hora de partir!',
          body:
            data.fiscalData.status_id === 3
              ? 'A documentação da sua viagem foi gerada. Lembre-se de sempre portar os documentos físicos. Dirija com segurança e boa viagem!'
              : 'Você recebeu uma nova ordem de coleta, toque para ver mais detalhes. Boa viagem!',
          type: 'APP_NOTIFICATION',
          users_id: [data.driver.id],
          payload: { action: 'OPEN_COLLECT_ORDER' },
        });
      } catch (error) {
        //
      }
    }

    setData((old) => ({
      ...old,
      registeredTravel: response.data.id,
    }));

    // 5722: pelo Kanban, a tela abre a viagem criada direto, sem o modal.
    if (!data.controlTower) setModalName('CreatedTravel');

    return response.data.id;
  } catch (err) {
    if (savedAttendance) {
      setData((old) => ({ ...old, registeredTravel: savedAttendance }));
      showSnackbar(
        'Viagem salva. Uma atualização auxiliar falhou; confira os detalhes da viagem.',
        { type: 'warning' },
      );
      return savedAttendance;
    }
    let message = 'Erro ao cadastrar viagem!';

    if (err?.response?.data?.message) {
      message = err?.response?.data?.message;
    } else if (err?.response?.data?.error) {
      message = err.response?.data?.error;
    } else if (err?.response?.data?.errors?.length > 0) {
      message = err.response?.data?.errors.map((errorMessage) => errorMessage).join(', ');
    }

    if (message.slice(0, 22) === 'FLEET_MANAGEMENT_ERROR') {
      const formatMessage = message.replace(/^FLEET_MANAGEMENT_ERROR/, '');

      showSnackbar(`Erro ao cadastrar viagem! ${formatMessage}`, {
        type: 'error',
        duration: 20000,
      });
    } else {
      showSnackbar(`Erro ao cadastrar viagem! ${message}`, {
        type: 'error',
      });
    }

    return false;
  } finally {
    setIsLoading(false);
    setModalName('');
  }
}
